import { ListViewIcon, MapLargeIcon, TilesViewIcon } from "@flat-ui";
/** Available view modes for each subject type */
export const SUBJECT_VIEW_MODES = {
  projects: ["cards", "list", "map"],
  groups: ["cards", "list"]
};

/** Configuration for each view mode */
export const VIEW_MODES_CONFIG = {
  cards: {
    tooltipTitle: "Tiles view",
    iconComponent: TilesViewIcon
  },
  list: {
    tooltipTitle: "List view",
    iconComponent: ListViewIcon
  },
  map: {
    tooltipTitle: "Map view",
    iconComponent: MapLargeIcon
  }
};